import { ReactNode, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children?: ReactNode;
  id: string;
}
export const Portal = ({ children, id }: PortalProps) => {
  const [target, setTarget] = useState<HTMLElement>();
  useLayoutEffect(() => {
    const target = document.getElementById(id);
    if (target instanceof HTMLElement) {
      setTarget(target);
    }
  }, [id]);
  return target && createPortal(children, target);
};
